import React from 'react';
import { Brikk } from 'components/Brikk';
import Draggable from 'components/drag-and-drop/Draggable';
import { useMaintenance } from 'services/maintenance/planned-maintenance/hook';
import { SeeMoreButton } from 'components/form-elements/buttons/SeeMoreButton';
import { UpgradePreview } from 'components/brikks/home/Upgrade/components/UpgradePreview';
import { UpgradeModal } from 'components/brikks/home/Upgrade/components/UpgradeModal';
import { BrikkModal } from 'components/modals/BrikkModal';
import { ShouldRender } from 'components/ShouldRender';
import { UpgradeIcon } from 'assets/icons/brikks/UpgradeIcon';
import { InfoButton } from 'components/form-elements/buttons/InfoButton';
import { BrikkInfoModal } from 'components/modals/BrikkInfoModal';
import { getTenantIDBasedOnURL } from 'global/tenant-config';
import { LKF } from 'global/tenant-config/tenants';

export const Upgrade = ({ position, status, code, name }) => {
  const [isModalOpen, setIsModalOpen] = React.useState(false);
  const [isInfoModalOpen, setIsInfoModalOpen] = React.useState(false);
  const tenantId = getTenantIDBasedOnURL();

  const { maintenance: { plannedMaintenance }, isLoading } = useMaintenance();

  const handleInfoModal = (e) => {
    e.stopPropagation();
    setIsInfoModalOpen(!isInfoModalOpen);
  };

  const handleOpenModal = (e) => {
    e.stopPropagation();
    setIsModalOpen(true);
  };

  return (
    <ShouldRender condition={isLoading || plannedMaintenance?.length}>
      <Draggable position={position}>
        <Brikk
          isLoading={isLoading}
          brikkKey={code}
          name={name}
          status={status}
          disabled={tenantId === LKF}
        >
          <Brikk.Header
            icon={<UpgradeIcon />}
            heading="maintenanceHomeBrikk"
            brikkKey={code}
            status={status}
          />

          <Brikk.Content>
            <UpgradePreview />
          </Brikk.Content>

          <Brikk.Button>
            <SeeMoreButton
              onClick={handleOpenModal}
              brikkNameIntl="upgradeApartment"
              disabled={tenantId === LKF}
            />
            <InfoButton
              showModal={isInfoModalOpen}
              onClick={handleInfoModal}
            />
          </Brikk.Button>
        </Brikk>
      </Draggable>

      <BrikkInfoModal
        title="Maintenance info"
        // info={info}
        showModal={isInfoModalOpen}
        onClick={() => setIsInfoModalOpen(!isInfoModalOpen)}
      />

      <BrikkModal
        twoGrid
        isOpen={isModalOpen}
        heading="maintenance"
        onClose={() => setIsModalOpen(false)}
      >
        <UpgradeModal />
      </BrikkModal>
    </ShouldRender>
  );
};
